import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { state, style, transition, animate, trigger, AUTO_STYLE } from '@angular/animations';

import 'rxjs/add/operator/filter';
import { MenuService } from '../../shared/services/menu.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { LocalStorageService } from '../../shared/services/loca-storage.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AlertService } from '../../../../src/app/shared/services/alert.service';
import { Location } from '@angular/common'

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('mobileMenuTop', [
      state('no-block, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('yes-block',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('no-block <=> yes-block', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})
export class ContentLayoutComponent implements OnInit, AfterViewInit {

 
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  chatToggle = 'out';
  chatInnerToggle = 'off';
  innerHeight: string;
  isScrolled = false;
  isCollapsedMobile = 'no-block';
  toggleOn = true;
  windowWidth: number;
  countM: any = "on";
  @ViewChild('searchFriends') search_friends: ElementRef;
  @ViewChild('toggleButton') toggle_button: ElementRef;
  @ViewChild('sideMenu') side_menu: ElementRef;

  config: any;
  user: any;
  userMenu: any[];
  constructor(public menuItems: MenuService,
      private storageService: LocalStorageService
    , private router: Router
    , private route: ActivatedRoute
    , private authService: AuthService
    , public titleService: Title
    , private alertService: AlertService
    , private location: Location) {
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
  }

  ngOnInit() {
    this.authService.getSession().then(
      (user: any) => {
        this.user = user;
        const urls = this.router.routerState.snapshot.url.split('/');
        this.userMenu = this.menuItems.getNavMenu(urls[1]);
      }
    ).catch((e) => {
      console.log('ContentLayoutComponent->ngAfterViewInit', e);
    });
  }
  ngAfterViewInit(): void { }

  onClickedOutside(e: Event) {
    if (this.windowWidth < 768)
      document.querySelector('#pcoded').setAttribute('vertical-nav-type', 'offcanvas');
      
    if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
  }

  Outside() {
    if(this.windowWidth < 768){
      this.countM ="off"
      document.querySelector('#pcoded').setAttribute('vertical-nav-type', 'offcanvas');
    }
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  setMenuAttributs(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.deviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'push';
    } else if (windowWidth < 768) {
      this.deviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.deviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  toggleOpened() {
    this.router.url;
     if (this.windowWidth < 768) {
      if(this.verticalNavType === 'offcanvas'){
        document.querySelector('#pcoded').setAttribute('vertical-nav-type', 'expanded');
          if(this.countM == 'off'){
            document.querySelector('#pcoded').setAttribute('vertical-nav-type', 'offcanvas');
            this.countM = 'on';
          }
      }  
      
    } else {
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    }
  }
  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onScroll(event) {
    this.isScrolled = false;
  }

  onLogout() {
    let token = this.authService.getTokenUser();
    this.authService.logout(token,{
      success: (resp) => {
        if (resp.data.code === 0) {
          this.authService.removeToken();
        } else {
          this.alertService.openSwal({
            text: resp.data.msg,
            type: 'error'
          });
        }
      }, error: (err) => {
        console.log('error', err);
      }
    });
  }

  changePassword(){
    this.router.navigate(['/profile']);
  }

  backClicked() {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/layouts/content-layout/content-layout.component.ts